import { render, staticRenderFns } from "./advertisement-modal.vue?vue&type=template&id=81539df4&scoped=true"
import script from "./advertisement-modal.vue?vue&type=script&lang=js"
export * from "./advertisement-modal.vue?vue&type=script&lang=js"
import style0 from "./advertisement-modal.vue?vue&type=style&index=0&id=81539df4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81539df4",
  null
  
)

export default component.exports